import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import './Productdetails.css';
import Nav from "../../components/nav/nav";
import Footer from "../../components/footer/Footer";
import LoginPopup from "../../components/Login/loginPopup";
import { addToCart } from "../../utils/addtocart";

const ProductDetails = () => {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [added, setAdded] = useState(false);
  const backendurl = "https://host.aizoplug.com";

  // FETCH PRODUCT
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);

        const res = await fetch(
          `${backendurl}/ecommerce/products?product_id=${id}`
        );
        const data = await res.json();

        if (data.success) {
          setProduct(data.data);

          if (data.data.images?.length > 0) {
            setMainImage(`https://api.aizoteq.com:3000` + data.data.images[0]);
          }
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  // SHIMMER LOADING
  if (loading) {
    return (
      <div className="product-detail-page">
        <Nav />

        <div className="product-detail-container">
          <div className="product-main">

            {/* LEFT SHIMMER */}
            <div className="product-gallery">
              <div className="shimmer shimmer-image"></div>

              <div style={{ display: "flex", marginTop: "10px" }}>
                <div className="shimmer shimmer-thumb"></div>
                <div className="shimmer shimmer-thumb"></div>
                <div className="shimmer shimmer-thumb"></div>
              </div>
            </div>

            {/* RIGHT SHIMMER */}
            <div className="product-info">
              <div className="shimmer shimmer-title"></div>

              <div className="shimmer shimmer-text"></div>
              <div className="shimmer shimmer-text"></div>
              <div className="shimmer shimmer-text"></div>

              <div className="shimmer shimmer-price"></div>
            </div>

          </div>
        </div>

        <Footer />
      </div>
    );
  }

  if (!product) {
    return <p style={{ textAlign: "center" }}>Product not found</p>;
  }

  // ADD TO CART
  const handleAddToCart = async () => {
    const cartProduct = {
      id: product.product_id
    };

    const success = await addToCart(cartProduct, quantity, () => setShowLogin(true));

    if (success) {
      setAdded(true);

      setTimeout(() => {
        setAdded(false);
      }, 1500);
    }
  };

  return (
    <div className="product-detail-page">
      <Nav />

      <div className="product-detail-container">
        {/* TOP SECTION: Images + Basic Info */}
        <div className="product-main">
          {/* LEFT: IMAGES */}
          <div className="product-gallery">
            <div className="main-image">
              <img src={mainImage} alt="Product" />
            </div>

            <div className="thumbnail-list">
              {product.images?.map((img, index) => (
                <img
                  key={index}
                  src={'https://api.aizoteq.com:3000' + img}
                  alt="thumb"
                  onClick={() => setMainImage('https://api.aizoteq.com:3000' + img)}
                />
              ))}
            </div>
          </div>

          {/* RIGHT: DETAILS */}
          <div className="product-info">
            <h2 className="product-title">
              {product.details?.title}
            </h2>

            <p className="product-description">
              {product.details?.description}
            </p>

            <div className="price-section">
              <span className="new-price">
                ₹{product.details?.price || product.mrp} <small style={{ fontSize: "12px" }}>(incl. GST)</small>
              </span>
            </div>
            {/* <div className="product-quantity">
              <button onClick={() => setQuantity(q => Math.max(1, q - 1))}>-</button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity(q => q + 1)}>+</button>
            </div> */}

            {/* ADD TO CART */}
            <button
              className={`add-to-cart-btn ${added ? "added" : ""}`}
              onClick={handleAddToCart}
            >
              {added ? "✓ ADDED" : "ADD TO CART"}
            </button>
          </div>
        </div>

        {/* BOTTOM SECTION: Features + Specifications (Two columns on desktop) */}
        <div className="product-additional-info">
          {/* Features Column */}
          {product.details?.features && product.details.features.length > 0 && (
            <div className="features-section">
              <h3>Features</h3>
              <ul>
                {product.details.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Specifications Column */}
          {product.details?.specifications &&
            Object.keys(product.details.specifications).length > 0 && (
              <div className="specifications-section">
                <h3>Specifications</h3>
                <table className="specs-table">
                  <tbody>
                    {Object.entries(product.details.specifications).map(
                      ([key, value], index) => (
                        <tr key={index}>
                          <th>{key}</th>
                          <td>{value}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            )}
        </div>
      </div>

      <Footer />

      <LoginPopup
        show={showLogin}
        onClose={() => setShowLogin(false)}
      />
    </div>
  );
};

export default ProductDetails;